import * as Sentry from '@sentry/react';

// loginHint carries PII (a clinician's Epic username/email) in the query string of the Epic
// SSO handoff URL. Scrub it wherever Sentry captures a URL, since replay/tracing/breadcrumbs
// would otherwise persist it.
const scrubLoginHint = (url?: string): string | undefined => {
  if (!url) return url;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.searchParams.has('loginHint')) {
      parsed.searchParams.set('loginHint', '[Filtered]');
    }
    return parsed.toString();
  } catch {
    return url;
  }
};

export const initSentry = () => {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],
      environment: import.meta.env.MODE,
      // Performance Monitoring
      tracesSampleRate: 1.0,
      // Session Replay
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
      beforeBreadcrumb(breadcrumb) {
        if (breadcrumb.data?.url) {
          breadcrumb.data.url = scrubLoginHint(breadcrumb.data.url);
        }
        if (breadcrumb.data?.to) {
          breadcrumb.data.to = scrubLoginHint(breadcrumb.data.to);
        }
        if (breadcrumb.data?.from) {
          breadcrumb.data.from = scrubLoginHint(breadcrumb.data.from);
        }
        return breadcrumb;
      },
      beforeSend(event) {
        if (import.meta.env.DEV) {
          return null;
        }
        if (event.request?.url) {
          event.request.url = scrubLoginHint(event.request.url);
        }
        return event;
      }
    });
  }
};
